import React, { useRef } from 'react';
import s from './FileInput.module.scss';
import classNames from 'classnames';

type FileInputProps = {
    onFilesSelected: (files: File[]) => void;
    children: React.ReactNode;
    accept: string;
    multiple: boolean;
    file?: File;
};

export const FileInput: React.FC<FileInputProps> = ({
    onFilesSelected,
    children,
    accept,
    multiple = true,
    file,
}) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = event.target.files;
        if (!selectedFiles || selectedFiles.length === 0) return;

        const newFiles = Array.from(selectedFiles);
        onFilesSelected(newFiles); 

        event.target.value = ''; 
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length === 0) return;

        const newFiles = Array.from(droppedFiles);
        onFilesSelected(newFiles);
    };

    const handleDivClick = () => {
        fileInputRef.current?.click();
    };

    return (
        <section className={s.dragDrop}>
            <div
                className={classNames(s.documentUploader , {
                    [s.documentUploaderActive] : !!file
                })}
                onDrop={handleDrop}
                onDragOver={event => event.preventDefault()}
                onClick={handleDivClick}
            >
                {children}

                <input
                    type="file"
                    hidden
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept={accept}
                    multiple={multiple}
                />
            </div>
        </section>
    );
};
